import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Observable, map } from 'rxjs';
import { CognitoService } from '../../core/services/cognito.service';
import { AuthService } from '../../features/auth/auth.service';
import { User } from '../../core/interfaces/user.interface';
import { ChangePasswordDialogComponent } from './change-password-dialog/change-password-dialog.component';

@Component({
  selector: 'app-home-layout',
  imports: [RouterModule, CommonModule, ChangePasswordDialogComponent],
  templateUrl: './home-layout.component.html',
  styleUrl: './home-layout.component.css',
  standalone: true
})
export class HomeLayoutComponent {
  sidebarVisible: boolean = false; // Sidebar is initially collapsed
  isMobile: boolean = false;
  isUserMenuOpen: boolean = false; // User menu dropdown state
  showChangePasswordDialog: boolean = false;
  userName$: Observable<string>;

  constructor(
    private router: Router, 
    private cognitoService: CognitoService,
    private authService: AuthService
  ) { // Replace 'any' with your actual cognitoService type
    this.userName$ = this.authService.currentUser$.pipe(map(user => this.toDisplayName(user)));

    // Check if it's mobile on init
    this.checkScreenSize();
    
    // Listen for window resize events
    window.addEventListener('resize', () => this.checkScreenSize());

    // Add click event listener to close dropdown when clicking outside
    window.addEventListener('click', (e: Event) => {
      // Check if click is outside the user menu
      if (this.isUserMenuOpen && !(e.target as HTMLElement).closest('.user-menu-container')) {
        this.isUserMenuOpen = false;
      }
    });
  }
    // Check screen size and update isMobile flag
  checkScreenSize(): void {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth < 768; // 768px is the md breakpoint in Tailwind
    
    // If changing from desktop to mobile, close sidebar
    if (!wasMobile && this.isMobile && this.sidebarVisible) {
      this.sidebarVisible = false;
    }
  }
    toggleSidebar(): void {
    this.sidebarVisible = !this.sidebarVisible;
    
    // Force a browser reflow to ensure animations are applied
    setTimeout(() => {
      // Force reflow to ensure the top position is applied immediately
      if (this.isMobile) {
        const sidebar = document.querySelector('.sidebar') as HTMLElement;
        if (sidebar) {
          sidebar.style.top = '4rem';
          sidebar.style.position = 'fixed';
          sidebar.style.zIndex = '9999';
        }
      }
    }, 10);
  }

  toggleUserMenu(event: Event): void {
    // Stop propagation to prevent the window click listener from immediately closing the menu
    event.stopPropagation();
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  openChangePassword(): void {
    this.isUserMenuOpen = false;
    this.showChangePasswordDialog = true;
  }

  logout(): void {
    this.cognitoService.signOut().then(() => {
      // Borrar del sesion storage los datos del usuario
      this.authService.setCurrentUser(null);
      
      this.router.navigate(['/auth/login']);
    }).catch(error => {
      console.error('Error during logout:', error);
      // Handle error (e.g., show a notification)
    });
  }

  private toDisplayName(user: User | null): string {
    if (!user) return '';
    const fullName = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();
    return fullName || user.name || '';
  }
}
